import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const DeleteProduct = () => {
    const navigate = useNavigate();
    const backendUrl = process.env.REACT_APP_BACKEND_URI;

    const [products, setProducts] = useState([]);

    useEffect(() => {
        if (!localStorage.getItem("adminToken")) navigate("/");
    }, [navigate]);

    useEffect(() => {
        fetch(`${backendUrl}/products`)
            .then(res => res.json())
            .then(setProducts);
    }, []);

    const deleteProduct = async (id) => {
        await fetch(`${backendUrl}/products/${id}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
            },
        });
        setProducts(products.filter(p => p._id !== id));
    };

    return (
        <div className="page-content">
            <h2>Delete Products</h2>

            <table className="admin-table" style={{ textAlign: 'center' }}>
                <thead>
                    <tr><th>Image</th><th>Title</th><th>Action</th></tr>
                </thead>
                <tbody>
                    {products.map(p => (
                        <tr key={p._id}>
                            <td><img src={p.images[0]} width="80" alt="" /></td>
                            <td>{p.title}</td>
                            <td>
                                <button className="delete-btn" onClick={() => deleteProduct(p._id)}>
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DeleteProduct;
